import React, { useState } from 'react';
import './PhoneDetail.css';
import iconBack from '../../assets/images/icon-back.svg';
import phoneZFold7 from '../../assets/images/phone-zfold7.png';
import consultPhone from '../../assets/images/consult-phone.svg';
import consultChat from '../../assets/images/consult-chat.svg';
import consultKakao from '../../assets/images/consult-kakao.svg';

interface PhoneDetailProps {
  onBack: () => void;
}

const PhoneDetail: React.FC<PhoneDetailProps> = ({ onBack }) => {
  const [selectedCarrier, setSelectedCarrier] = useState('SK');
  const [selectedCapacity, setSelectedCapacity] = useState('512GB');
  const [selectedDiscount, setSelectedDiscount] = useState('선택약정');
  const [selectedInstallment, setSelectedInstallment] = useState('24개월');
  const [isBottomSheetExpanded, setIsBottomSheetExpanded] = useState(false);
  const [dragStartY, setDragStartY] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);

  const handleTouchStart = (e: React.TouchEvent) => {
    setDragStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    const currentY = e.touches[0].clientY;
    const diff = dragStartY - currentY;

    if (diff > 0 && diff < 600) {
      setDragOffset(diff);
    } else if (diff < 0 && isBottomSheetExpanded) {
      const collapseDiff = Math.abs(diff);
      if (collapseDiff < 200) {
        setDragOffset(-collapseDiff);
      }
    }
  };

  const handleTouchEnd = () => {
    if (dragOffset > 150) {
      setIsBottomSheetExpanded(true);
    } else if (dragOffset < -50) {
      setIsBottomSheetExpanded(false);
    }
    setDragOffset(0);
  };

  return (
    <div className="phone-detail-container">
      <div className="phone-detail-header">
        <button className="back-btn" onClick={onBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="phone-detail-content">
        <h1 className="detail-title">상세정보</h1>

        <div className="section">
          <h2 className="section-subtitle">갤럭시 Z 폴드7</h2>
          <div className="phone-preview-card">
            <img src={phoneZFold7} alt="갤럭시 Z 폴드7" className="phone-image" />
            <div className="color-info">
              <p className="color-name">실버 쉐도우</p>
              <div className="color-dots">
                <span className="color-dot active"></span>
                <span className="color-dot"></span>
                <span className="color-dot"></span>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <h3 className="section-title">이동할 통신사</h3>
          <div className="carrier-grid">
            {['SK', 'KT', 'LG U+'].map((carrier) => (
              <div
                key={carrier}
                className={`carrier-box ${selectedCarrier === carrier ? 'active' : ''}`}
                onClick={() => setSelectedCarrier(carrier)}
              >
                <div className="carrier-logo">{carrier}</div>
                <p>{carrier}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <h3 className="section-title">용량 선택</h3>
          <div className="option-grid-two">
            {['256 GB', '512 GB'].map((capacity) => (
              <button
                key={capacity}
                className={`option-btn ${selectedCapacity === capacity ? 'active' : ''}`}
                onClick={() => setSelectedCapacity(capacity)}
              >
                {capacity}
              </button>
            ))}
          </div>
        </div>

        <div className="section">
          <h3 className="section-title">할인 방법</h3>
          <div className="option-grid-two">
            <button
              className={`option-btn-col ${selectedDiscount === '공통지원금' ? 'active' : ''}`}
              onClick={() => setSelectedDiscount('공통지원금')}
            >
              <p className="option-title">공통지원금</p>
              <p className="option-sub">기기값 할인</p>
            </button>
            <button
              className={`option-btn-col ${selectedDiscount === '선택약정' ? 'active' : ''}`}
              onClick={() => setSelectedDiscount('선택약정')}
            >
              <p className="option-title">선택약정</p>
              <p className="option-sub">요금 25% 할인</p>
            </button>
          </div>
        </div>

        <div className="section">
          <h3 className="section-title">단말기 할부 개월 수</h3>
          <div className="option-grid-two">
            {['일시불', '24개월'].map((installment) => (
              <button
                key={installment}
                className={`option-btn ${selectedInstallment === installment ? 'active' : ''}`}
                onClick={() => setSelectedInstallment(installment)}
              >
                {installment}
              </button>
            ))}
          </div>
        </div>

        <div className="section">
          <h3 className="section-title">요금제</h3>
          <div className="plan-badge">
            <span className="plan-badge-text">
              프리미엄 10.9 요금제를 <strong>189일</strong> 사용해요
            </span>
          </div>

          <div className="plan-detail-card">
            <div className="plan-row">
              <span className="plan-label">데이터</span>
              <span className="plan-value">완전무제한</span>
            </div>
            <div className="plan-row">
              <span className="plan-label">통화 • 문자</span>
              <span className="plan-value">통화 무제한 / 문자 무제한</span>
            </div>
            <div className="plan-row">
              <span className="plan-label">부가통화</span>
              <span className="plan-value">300 분</span>
            </div>
            <div className="plan-row">
              <span className="plan-label">기본 월 요금</span>
              <span className="plan-value">109,000 원</span>
            </div>
            <div className="plan-row">
              <span className="plan-label">유지기간</span>
              <span className="plan-value">183 일</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`bottom-sheet ${isBottomSheetExpanded ? 'expanded' : ''}`}
        style={{
          transform: isBottomSheetExpanded
            ? `translateY(${Math.min(0, dragOffset)}px)`
            : `translateY(-${dragOffset}px)`,
        }}
      >
        <div
          className="bottom-sheet-handle"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="handle-bar"></div>
        </div>
        <div className="bottom-sheet-content">
          <div className="price-row-main">
            <span className="price-label-main">구매 원금</span>
            <div className="price-group">
              <span className="price-value-main">360,000 원</span>
              <button
                className="expand-btn"
                onClick={() => setIsBottomSheetExpanded(!isBottomSheetExpanded)}
              >
                {isBottomSheetExpanded ? '▼' : '▲'}
              </button>
            </div>
          </div>

          {isBottomSheetExpanded && (
            <div className="expanded-content">
              {/* 구분선 */}
              <div className="horizontal-divider" />

              {/* 상담 버튼 영역 */}
              <div className="consult-buttons">
                <button className="consult-btn">
                  <img src={consultPhone} alt="전화 상담" className="consult-icon" />
                  <span className="consult-label">전화 상담</span>
                </button>
                <button className="consult-btn">
                  <img src={consultChat} alt="채팅 상담" className="consult-icon" />
                  <span className="consult-label">채팅 상담</span>
                </button>
                <button className="consult-btn">
                  <img src={consultKakao} alt="카톡 상담" className="consult-icon" />
                  <span className="consult-label">카톡 상담</span>
                </button>
              </div>
            </div>
          )}

          <button className="final-btn">최종 혜택 확인</button>
        </div>
      </div>
    </div>
  );
};

export default PhoneDetail;
